import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../common';
import { CountOfOrderingProviders, IB2CNotification, IB2CPreview } from './models';

export const notificationApiSlice = createApi({
  reducerPath: 'notifications/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'notifications/',
  }),
  endpoints: builder => ({
    createB2CNotifications: builder.query<unknown, any>({
      query: data => ({
        url: 'patient',
        method: 'POST',
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    }),
    createB2BNotifications: builder.query<unknown, any>({
      query: data => ({
        url: 'ordering-provider',
        method: 'POST',
        data,
      }),
    }),
    getCountOfPatients: builder.query<unknown, IB2CNotification>({
      query: taskId => ({
        url: `patients-previews/${taskId}`,
        method: 'GET',
      }),
    }),
    getCountOfOrderingProviders: builder.query<CountOfOrderingProviders, number>({
      query: selectionId => ({
        url: `ordering-provider-previews/${selectionId}`,
        method: 'GET',
      }),
      transformResponse: (response: IAxiosResponse<CountOfOrderingProviders>) => ({
        ...response.data,
      }),
    }),
    getActivePatientNotifications: builder.query<number[], number[]>({
      query: data => ({
        url: 'filter-selection-ids-with-active-patient-notifications',
        method: 'POST',
        data,
      }),
      transformResponse: (response: IAxiosResponse<number[]>) => response.data,
    }),
    getB2CPreview: builder.query<IB2CPreview, unknown>({
      query: data => ({
        url: 'b2c-preview',
        method: 'GET',
        data,
      }),
      transformResponse: (response: IAxiosResponse<IB2CPreview>) => response.data,
    }),
  }),
});
